export enum CreditLineRequestFundingType {
    Buyer = 'buyer',
    Supplier = 'supplier',
}
